import { createClient } from 'contentful';

const client = createClient({
  space: 'as7nrmxjyx19',
  accessToken: process.env.VUE_CONTENTFUL_ACCESS_TOKEN || '9d912596ede3629cc8b0450eae2af66d11b0340c66be380447045464064ef023',
  host: process.env.VUE_CONTENTFUL_HOST || 'preview.contentful.com'
});

export async function getSite (hostname) {
  return client.getEntries({
    'content_type': 'location',
    'fields.Hostname': hostname,
    'limit': 1,
    'include': 5
  }).then(results => {
    const site = results && results.items && results.items.length && results.items[0].fields || {};
    const theme = site.theme && site.theme.fields || {};
    delete site.theme;
    return {
      site,
      theme
    };
  })
};
